import { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Fallback pairs shown only if the /api/rates call has not returned yet.
const FALLBACK = [
  { pair: 'GBP / EUR', rate: '1.1671', delta: '+0.00%' },
  { pair: 'GBP / USD', rate: '1.3474', delta: '+0.00%' },
  { pair: 'EUR / USD', rate: '1.1542', delta: '+0.00%' },
  { pair: 'GBP / AUD', rate: '1.9094', delta: '+0.00%' },
  { pair: 'GBP / CAD', rate: '1.881',  delta: '+0.00%' },
  { pair: 'GBP / JPY', rate: '212.69', delta: '+0.00%' },
  { pair: 'GBP / AED', rate: '4.9496', delta: '+0.00%' },
  { pair: 'GBP / ZAR', rate: '21.83',  delta: '+0.00%' },
];

export default function Ticker() {
  const [pairs, setPairs] = useState(FALLBACK);

  useEffect(() => {
    let cancelled = false;
    const fetchRates = async () => {
      try {
        const res = await axios.get(`${API}/rates`);
        if (!cancelled && res.data?.pairs?.length) {
          setPairs(
            res.data.pairs.map((p) => ({
              pair: p.pair,
              rate: typeof p.rate === 'number' ? p.rate.toFixed(p.rate < 10 ? 4 : 2) : p.rate,
              delta: p.delta,
            }))
          );
        }
      } catch {
        // keep fallback
      }
    };
    fetchRates();
    const id = setInterval(fetchRates, 15000);
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, []);

  const items = [...pairs, ...pairs];

  return (
    <section className="relative py-6 bg-[#0B3B2E] text-[#F5F1E8] overflow-hidden">
      <div className="flex ticker-track whitespace-nowrap">
        {items.map((t, i) => (
          <div key={i} className="flex items-center gap-4 px-8">
            <span className="font-serif text-[15px] tracking-wide">{t.pair}</span>
            <span className="text-[15px] font-medium text-[#C8944B]">{t.rate}</span>
            <span
              className={`text-[12px] px-2 py-0.5 rounded-full ${
                String(t.delta).startsWith('+')
                  ? 'bg-[#C8944B]/20 text-[#F5E6C9]'
                  : 'bg-[#F5F1E8]/10 text-[#F5F1E8]/70'
              }`}
            >
              {t.delta}
            </span>
            <span className="w-1 h-1 rounded-full bg-[#F5F1E8]/25" />
          </div>
        ))}
      </div>
    </section>
  );
}
